
<template>
  <div style="display:flex;flex-direction:column">
    <div class="boxbg boxbg1" style="height: 30%">
      <div class="boxTitle">AEO进出口总值</div>
      <div class="boxTitle1" style="font-size: 18px;">AEO Import and Export Ratio</div>
      <!-- <div class="echart" style="display: flex;justify-content: center;">
       <dv-active-ring-chart :config="config" style="width:250px;height:120px" />
      </div> -->
      <div class="totals-new">AEO进出口总值:{{aeoTotalIAmount}}亿</div>
      <div class="totals-new1">AEO Trade Volume: RMB {{aeoTotalIAmount1}}billion</div>
      <div class="box-title" v-if="provinceName" ><span>{{provinceName}}</span></div>
    </div>

    <div class="boxbg boxbg2" style="min-height: 0px;flex:1;display: flex;flex-direction: column;">
      <div class="boxTitle" style="display: flex;justify-content: space-between;height: 28px;">
        AEO贸易伙伴（进出口）
       </div>
       <div class="boxTitle1" style="display: flex;justify-content: space-between;">
         AEO Trading Partners (Import and Export)
        </div>
      <div class="echart capsuleChart" style="min-height: 0px;flex:1">
        <dv-capsule-chart :config="config3" style="width:100%;height:100%" />
      </div>
      <div class="box-title" v-if="customName" ><span>{{customName}}</span><span>{{customEn}}</span></div>
    </div>
    <div class="boxbg boxbg3" style="height: 25%;margin-bottom: 0px;display: flex;flex-direction: column;">
      <div class="boxTitle">AEO贸易分布（进出口）</div>
      <div class="boxTitle1">AEO Trade Distribution (Import and Export)</div>
      <div class="echart" style="min-height: 0px;flex:1">
        <div id="echart26" ref="chartContainer1"  style="height:100%;width: 100%;"></div>
      </div>
      <div class="box-title" v-if="customName" ><span>{{customName}}</span><span>{{customEn}}</span></div>
    </div>

  </div>

</template>

<script>
  import * as echarts from 'echarts';
  import common from '../../components/api';
	export default {
		name: "eight",
    props:{
       customCode:{
          type:String
      }
    },
		data() {
      return {
        config:{
          radius: '60%',
          activeRadius: '65%',
          data: [],
          activeTimeGap:10000000000,
          digitalFlopStyle: {
            fontSize: 20
          }
        },
        config3:{
          data: [],
          showValue: true,
          unit: '亿元',
        },
        Chart:null,
        option:{},
        nationList:[],//国家
        countryCode:'',//国家code

        configData:[],
        timer1:null,
        index:0,
        areaList:[{countryCode:"HKG",countryName:"中国香港"},{countryCode:"MAC",countryName:"中国澳门"},{countryCode:"TWN",countryName:"中国台湾"}],
        area:'',
        aeoTotalIAmount:'',
        aeoTotalIAmount1:'',
        provinceName: '',
        customName: '',
        customEn: '',
      }
		},

    mounted() {

      this.$Bus.$on('getIAndETradeAmount', e => {
        this.provinceName = e.provinceName;
        this.aeoTotalIAmount = e.aeoTotalAmount;
        this.aeoTotalIAmount1 = (e.aeoTotalAmount/10).toFixed(2);
        this.config.data = [
          {
            name: '进出口',
            value: Number(e.aeoTotalAmount),
          },
          {
            name: '总值',
            value: Number(e.totalAmount) - Number(e.aeoTotalAmount),
          },
         ]
         this.config = {...this.config}
      })

      this.$Bus.$on('getCountryTradeAmountProportion', e => {
        let data = e.totalTradeAmountRankingList;
        let arr = [];
        for(let i=0;i<data.length;i++){
          let aeoTotalAmount = Math.floor(Number(data[i].aeoTotalAmount)*100)+'%'
          arr.push({ value: data[i].aeoTotalAmount, name: data[i].countryName+aeoTotalAmount })
        }
        this.datainfo(arr)
      })

      this.$Bus.$on('getCountryTradeAmountRanking', e => {
       // this.config3.unit = e.unit;
        this.customName = e.data.customName;
        this.customEn = e.data.customEn;

        let etradeAmountRankingList = e.data.totalTradeAmountRankingList;
        let seriesData = [];
        for(let i=0;i<etradeAmountRankingList.length;i++){
          seriesData.push({value:this.numbertoFixed(etradeAmountRankingList[i].aeoTotalAmount,e.unit),name:etradeAmountRankingList[i].countryName+etradeAmountRankingList[i].countryCode})
        }
        this.configData = seriesData;
        if(seriesData.length>8){//大于8才轮播
          console.log('999',this.configData)
          this.setData();
          console.log(133333)
        }else{

          console.log('000',this.configData)
          this.config3.data = this.configData;
          this.config3 = {...this.config3};
        }
      })
      setTimeout(()=>{this.startLegendScroll();},2000)
    },
   beforeDestroy() {
     clearInterval(this.timer1);
   },
    methods:{

      numbertoFixed(res,unit){
        let data;
        if(unit=='亿'){
          data = (Number(res) / 100000000).toFixed(2);
        }else{
          data = (Number(res) / 10000).toFixed(2);
        }
        return data;
      },
      setData(){
        clearInterval(this.timer1);
        let number = 8;//一行显示的个数
        this.config3.data = this.configData.slice(0, number);
        this.config3 = {...this.config3};
         console.log(this.config3.data,777)
        let length = Math.floor(this.configData.length/number);
        // console.log('**********', length)
        this.index = 0;

        this.timer1 = setInterval(()=>{
          // console.log(6666)
          if(length>this.index){
            // console.log('第',this.index,'页',this.index*number,(this.index+1)*number)
            this.config3.data = this.configData.slice(this.index*number, (this.index+1)*number);
            this.config3 = {...this.config3};
            this.index = this.index+1;
          }else{
            // console.log('第',this.index,'页',(this.index-1)*number,this.configData.length)
            this.config3.data = this.configData.slice((this.index-1)*number, this.configData.length);
            this.config3 = {...this.config3};
            this.index = 0;
          }
        },10000);

      },
      getSelect(){
        //获取国家
        this.$axios.post(common.apihost+'/aeo/tradeData/getCustomCountry').then(res =>{
            this.nationList = res.data.data;
        })
      },
      startLegendScroll() {
        this.$nextTick(()=>{
          const chart = echarts.getInstanceByDom(this.$refs.chartContainer1);
          if (chart) {
          	// 假设我们每秒滚动30个像素
          	setInterval(() => {
          		const currentOffset = chart.getOption().legend[0].scrollDataIndex;
          		chart.setOption({
          			legend: {
          				scrollDataIndex: currentOffset>10?0:(currentOffset + 5) // 滚动量
          			}
          		});
          	}, 10000);
          }
        })

      },
      datainfo(arr){
            //this.Chart1 = this.$echarts.init(document.getElementById('echart26'));
             const chart = echarts.init(this.$refs.chartContainer1);
            this.option1 = {
                   tooltip: {
                      trigger: 'item'
                    },
                    grid:{
                      left:'30%',
                      containLabel: true
                    },
                    legend: {
                        type: 'scroll',
                         orient: 'vertical',
                         right: 0,
                         top: 0,
                         bottom: 20,
                         padding:[10,0,10,0],
                        textStyle: {
                         fontSize: 18,
                          color: '#fff' // 设置文字颜色为白色
                        },
                        pageIconColor: '#aaa', // 翻页按钮的颜色
                        pageIconInactiveColor: '#2f4554', // 翻页按钮不激活时（即翻页到头时）的颜色
                        // pageTextStyle: { // 图例页信息的文字样式
                        //   color: '#cbcbcb'
                        // }
                    },

                    series: [
                      {
                        name: 'AEO进出口贸易分布',
                        type: 'pie',
                        radius: ['30%', '70%'],
                        center:['35%','50%'],
                        avoidLabelOverlap: false,
                        label: {
                          show: false,
                          position: 'right',
                          textStyle: {
                              color: '#fff' // 设置文字颜色为白色
                          }
                        },
                        data: arr
                      }
                    ]
                }
                chart.setOption(this.option1);
                //this.Chart1.setOption(this.option1);

      },
    }
	}

</script>

<style scoped>
  .boxTitle1{
    font-size: 14px;
  }
  .capsuleChart{
    padding-right:20px;
  }
  .capsuleChart /deep/ .label-column>div{
    font-size:17px!important;
  }
  .capsuleChart /deep/ .capsule-item-value{
    font-size:17px!important;
  }
  .capsuleChart /deep/ .unit-label>div,.capsuleChart /deep/ .unit-text{
    font-size:16px!important;
  }
  .totalText{
    font-size: 20px;
    color:#1AC7FD;
    font-family: '微软雅黑';
        font-weight: 400;
  }

  .rightNumber{
    display: flex;
    align-items: center;
    font-family: '微软雅黑';
    font-weight: 400;
    justify-content: center;
  }
  .imgBox{
    width: 70px;
    height: 70px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-radius: 188px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgBox img{
    width: 42px;
    height: 42px;
  }
  .numberText{
    border-width: 0px;
    width: 280px;
    height: 100px;
    background: inherit;
    background-color: rgba(26, 201, 255, 0.298039215686275);
    border: none;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    text-align: left;
    margin-left:15px;
    padding:15px 20px;
  }
  .boxbg1{
    /* background-color: rgba(49, 94, 245, 0.3); */
    background-color: rgba(98, 192, 220, 0.3);
  }
  .boxbg2{
    /* background-color: rgba(245, 232, 49, 0.3); */
    background-color: rgba(239, 150, 68, 0.3);
  }
  .boxbg3{
    /* background-color: rgba(49, 232, 245, 0.3); */
    background-color: rgba(183, 218, 198, 0.3);
  }
  
  .totals-new{
    font-size: 30px;
    text-align: center;
    padding-top: 45px;
    padding-bottom: 45px;
  }
  .totals-new1{
    font-size: 28px;
    text-align: center;
    padding-bottom: 5px;
  }

  .box-title{
    position: absolute;
    top: 0;
    right: -80px;
    background-color: #fff;
    color: #000000;
    width: 80px;
    display: flex;
    justify-content: center;
    border-radius: 0 10px 10px 0;
    padding: 20px 0
  }
  .box-title span{
    writing-mode: vertical-lr;
    font-size: 24px;
    font-family: '微软雅黑';
    font-weight: bold;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftNew/leftOne.vue